import React from 'react';

import { CampaignType } from 'src/actions/campaigns/campaignsResource';
import RecipientCollections from 'src/presentation/components/pages/proactiveCommunications/components/shared/RecipientCollections';
import AddEmailRecipientsForm from './AddEmailRecipientsForm';
import EmailCampaignContentDetails from './EmailCampaignContentDetails';

const EmailRecipientCollections = ({ root }) => (
  <RecipientCollections
    addRecipientFormComponent={AddEmailRecipientsForm}
    backButtonLabel="Proactive Email"
    campaignContentDetailsComponent={EmailCampaignContentDetails}
    campaignType={CampaignType.EMAIL}
    root={root}
  />
);

export default EmailRecipientCollections;
